/**
 * LoaderContainer.js. DO NOT apply var to these values. The var.less file has not loaded yet.
 * Created by calhosh on 9/22/2020.
 */
import React from 'react';
import AresLoader from './Common/Loaders/aresLoader';
import {getTheme} from '@ey/styled-theme';
import styled, {ThemeProvider} from 'styled-components';

const StyledAppContainer = styled.section`
	display: flex !important;
	width: 100% !important;
	overflow: hidden !important;
	.react-loading-skeleton {
		background: linear-gradient(119deg, var(--neutrals-bg-gradient1) 10%, var(--neutrals-bg-gradient2) 99%);
		display: inline-block;
		line-height: 1;
		width: 100% !important;
		height: 4rem !important;
		background-repeat: no-repeat;
		border-radius: 4px;
		animation: 1.2s ease-in-out 0s infinite normal none running animation-16jpnkj;
		padding: 0 !important;
	}
`;

const LoaderContainer = () => {
	return (
		<ThemeProvider theme={getTheme()}>
			<StyledAppContainer className="styledAppContainer">
				<AresLoader />
			</StyledAppContainer>
		</ThemeProvider>
	);
};

export default LoaderContainer;
